import React, {useRef, useState} from "react";

import moment from 'moment';
import { useTranslation } from "react-i18next";

import {Form, Card, Row, Col} from "react-bootstrap"
import HeaderCounters from "../HeaderCounters/HeaderCounters"
import { useGetUserProfileCounters } from "../../hooks/useOfProfile"

import sapFgIntegrationKey from "../../images/sapFieldGlassIntegrationKey.png";
import sg3IntegrationKey from "../../images/sg3IntegrationKey.png"

import ProfileOptionButtons from '../Controls/Buttons/ProfileOptionButtons';
import { Shimmer, ShimmerElementsGroup, ShimmerElementType } from '@fluentui/react/lib/Shimmer';

import {authGetPictureProfile} from '../../actions/auth-action'

import imgNN from '../../images/nn.png'
import { isNullUndefinedOrEmpty } from "../../common/Helpers";
function toDataURL(url, callback) {
    let xhr = new XMLHttpRequest();
    xhr.onload = function() {
      let reader = new FileReader();
      reader.onloadend = function() {
        callback(reader.result);
      }
      reader.readAsDataURL(xhr.response);
    };
    xhr.open('GET', url);
    xhr.responseType = 'blob';
    xhr.send();
}

const ProfileHeader = (props) => {

    const { t } = useTranslation();
    
    const userInfo = props.user;
    const isCurrentUser = props.isCurrentUser;
    const showEditProfile = props.showEditProfile;
    const showResetPassword = props.showResetPassword;
    
    const showSystemConnections = props.showSystemConnections;

    const systemConnections = props.systemConnections;

    const imgProfileWidthXs = useRef();
    const imgProfileWidthXl = useRef();

    const [userHeaderCounters, setUserHeaderCounters] = useState(null);
    useGetUserProfileCounters((userInfo !== null) ? userInfo.username: null, userHeaderCounters, setUserHeaderCounters);

    const getBase64Image = async (url, isCurrentUser) => {
        if (isCurrentUser) {
            toDataURL(url, function(dataUrl) {
                imgProfileWidthXs.current.src = dataUrl;
                imgProfileWidthXl.current.src = dataUrl;
            })
        }
        else {
            return userInfo.pictureUrl !== null ? userInfo.pictureUrl : imgNN;
        }
    }
    
    const userOptionMenuItems = userInfo !== null ? [
        {
            text: t('data-lang-btn-changepassword'),
            iconName: 'Encryption',
            key: 'changepassword',
            stateValue: { userName: userInfo.username },
            show: showResetPassword
        },
        {
            text: t('data-lang-btn-editprofile'),
            iconName: 'EditContact',
            key: 'edituser',
            stateValue: { userName: userInfo.username },
            show: showEditProfile
        },
        {
            text: t('data-lang-btn-aadinvite'),
            iconName: 'ContactCardSettings',
            key: 'aadinvite',
            stateValue: { userName: userInfo.username },
            show: !isNullUndefinedOrEmpty(userInfo.formBasedAuthEnabled) ? (!userInfo.formBasedAuthEnabled ? userInfo.azureActiveDirectoryAuthEnabled : false) : false
        }
    ] : [];

    const getUserPicture = async (obj) => {
        let path = Buffer.from(decodeURIComponent(obj), "base64").toString();
        
        if (path !== "") {
            await getBase64Image(path, isCurrentUser).then((response) => {
                return response;
            });
        }
        else {
            return imgNN;
        }
    }
    
    return (
        <>
            <Card className="rounded-3">
                <Card.Header>
                    <Card.Title>
                        <h4><b>{t('data-lang-pagename-profile')}</b>{ (userInfo && showResetPassword && showEditProfile) && <ProfileOptionButtons items={ userOptionMenuItems } userInfo={userInfo} /> }</h4> 
                    </Card.Title>
                </Card.Header>
                { userInfo &&
                    <>
                        <div data-html2canvas-ignore="true" className="mx-auto d-block d-sm-block d-md-none d-lg-none">  
                            <img className="rounded-circle border border-2 border-warning" alt="img" width={125} src={imgNN} ref={imgProfileWidthXs} ></img>
                        </div>
                        <div className="card-body card-horizontal">
                            <div data-html2canvas-ignore="true" className="pt-4 d-none d-sm-none d-md-block d-lg-block">  
                                <img className="rounded-circle border border-2 border-warning" alt="img" width={125} src={imgNN} ref={imgProfileWidthXl} ></img>
                            </div>
                            <Card.Body className="col-xs-12">
                                <Row>
                                    <Col xs={12} sm={12} md={6} lg={4} xl={4} className="text-center text-sm-center text-md-start">
                                        <Form.Label><b>{userInfo.firstName} {userInfo.lastName}</b></Form.Label>
                                        <Form.Label>{userInfo.email}</Form.Label>
                                        { (showSystemConnections && systemConnections) &&
                                            <Row>
                                            { systemConnections.map((item, index) =>
                                                <Col xs={6} sm={6} md={4} lg={3} xl={2} key={index}>
                                                    {
                                                        (item.name === "SG3" && item.linked) && <img className="rounded-3 border-warning p-1" alt="imgSistem" width={50} src={sg3IntegrationKey}></img>
                                                    }
                                                    {
                                                        (item.name === "FIELDGLASS" && item.linked) && <img className="rounded-3 border-warning p-1" alt="imgSistem" width={50} src={sapFgIntegrationKey}></img>
                                                    }
                                                </Col>
                                            )}
                                            </Row>
                                        }
                                    </Col>
                                    <Col xs={12} sm={12} md={6} lg={4} xl={4} className="text-center text-sm-center text-md-end ms-auto col-auto text-end">
                                        <HeaderCounters showDetail={true} detail={((userInfo.lastSignIn !== null)? t('data-lang-lbl-lastaccess') + ` ` + moment(userInfo.lastSignIn).format('DD/MM/YYYY HH:mm') : "")} textList={[t('data-lang-lbl-contracts'), t('data-lang-lbl-roles')]} counters={userHeaderCounters} />
                                    </Col>
                                </Row>
                            </Card.Body>
                        </div>
                    </>
                }
                { !userInfo &&
                    <Shimmer
                        customElementsGroup={
                            <div style={{ display: 'flex' }}>
                                <ShimmerElementsGroup
                                    shimmerElements={[
                                        { type: ShimmerElementType.circle, height: 125 },
                                        { type: ShimmerElementType.gap, width: 16, height: 125 },
                                    ]}
                                />
                                <ShimmerElementsGroup
                                    flexWrap
                                    width="100%"
                                    shimmerElements={[
                                        { type: ShimmerElementType.line, width: '100%', height: 10, verticalAlign: 'bottom' },
                                        { type: ShimmerElementType.line, width: '100%', height: 10 },
                                        { type: ShimmerElementType.line, width: '100%', height: 10 },
                                        { type: ShimmerElementType.line, width: '100%', height: 10 },
                                        { type: ShimmerElementType.gap, width: '100%', height: 25 },
                                    ]}
                                />
                            </div>
                        }
                        styles={{
                            root: {
                                width:"100%",
                                height:"150px",
                                backgroundColor: "white"}
                            }
                        }
                        className="pt-4"
                        isDataLoaded={userInfo !== null}>
                    </Shimmer>
                }
            </Card>
        </>
    );
};

export default ProfileHeader;


